import { Label, Pro, Publisher, Rightsholder } from '@disco/types/types/writer'
import { isGroupedOptions } from 'components/ds/SearchableDropdown'

export const getOptions = (
  priorityIds,
  entities: Pro[] | Label[] | Publisher[] | Rightsholder[],
) => {
  const prioritySet = new Set(priorityIds.map(id => id.toString()))

  const allOptions = entities.map(entity => ({
    id: entity.id.toString(),
    label: entity.name,
    data: entity,
  }))

  // If no priority IDs, return flat options
  if (priorityIds.length === 0) {
    return allOptions
  }

  // Split into priority and non-priority
  const priorityOptions = allOptions.filter(opt => prioritySet.has(opt.id))
  const otherOptions = allOptions.filter(opt => !prioritySet.has(opt.id))

  // Return grouped options with empty labels (separator groups)
  return [
    { label: '', options: priorityOptions },
    { label: '', options: otherOptions },
  ]
}

export const checkIfLoading = (value, options) => {
  if (!value) return false

  // Flatten options if grouped
  const flatOptions = isGroupedOptions(options)
    ? options.flatMap(g => g.options)
    : options

  return !flatOptions.some(opt => opt.id === value)
}
